(ns core.domain.schemas
  (:require [core.domain.validators :as validators]
            [schema.core :as s]))

(s/defschema PositiveInteger
  (s/constrained s/Int pos? "Positive integer required"))

(s/defschema PositiveNumber
  (s/constrained s/Num pos? "Positive number required"))

(s/defschema NonNegativeInteger
  (s/constrained s/Int (complement neg?) "Positive integer or zero required"))

(s/defschema NonNegativeNumber
  (s/constrained s/Num (complement neg?) "Positive number or zero required"))

(s/defschema RealNumber
  (s/constrained s/Num (complement NaN?) "Number cannot be NaN"))

(s/defschema URI
  (s/constrained s/Str validators/valid-uri? "URI must start with http(s)://"))

(s/defschema UUID-string
  (s/constrained s/Str validators/valid-uuid? "Must be UUID"))
